module.exports = __webpack_public_path__ + "img/PLN.9dbbb18f.png";